// Combo reutilizable de "Propietario". Carga los usuarios visibles
// para el usuario autenticado y selecciona uno. Si no se pasa value
// y onChange, se comporta como un campo no controlado dejando la
// decisión al servidor (default = creador).

import React, { useEffect, useState } from 'react';
import api from '../services/api';

let cache = null;
let cachePromise = null;

async function loadAssignableUsers() {
  if (cache) return cache;
  if (!cachePromise) {
    cachePromise = api.get('/users/assignable').then(r => {
      cache = Array.isArray(r.data) ? r.data : [];
      return cache;
    }).catch(() => { cache = []; return cache; }).finally(() => { cachePromise = null; });
  }
  return cachePromise;
}

export function invalidateOwnerCache() { cache = null; }

export default function OwnerSelect({ value, onChange, label = 'Propietario', includeEmpty = false }) {
  const [users, setUsers] = useState(cache || []);
  useEffect(() => { loadAssignableUsers().then(setUsers); }, []);
  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <select
        className="form-input"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value === '' ? null : Number.parseInt(e.target.value, 10))}
      >
        {includeEmpty && <option value="">— sin cambiar —</option>}
        {users.map(u => (
          <option key={u.id} value={u.id}>
            {u.name}{u.role?.name ? ` · ${u.role.name}` : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
